import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgCloud(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "cloud_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#cloud_svg__a)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, {
      children: [_jsx("path", {
        d: "M43.063 54.996c2.614.005 5.2-.537 7.596-1.592a18.905 18.905 0 006.323-4.537 19.108 19.108 0 003.983-6.718 19.232 19.232 0 00-1.228-15.274 19.029 19.029 0 00-5.004-5.982 18.83 18.83 0 00-6.965-3.45 18.735 18.735 0 00-7.75-.335 12.248 12.248 0 00-6.044-6.83 12.075 12.075 0 00-9.047-.716 12.198 12.198 0 00-7.023 5.798 12.383 12.383 0 00-1.098 9.09A15.078 15.078 0 006.2 29.16a15.354 15.354 0 00-4.197 10.9c.088 4.05 1.768 7.9 4.67 10.7a15.065 15.065 0 0010.8 4.235h25.59zM17.46 36.122h12.422M23.67 29.855v12.54",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M34.652 41.093h14.785M42.042 33.632V48.55M29.539 25.943h7.19M33.133 22.315v7.25",
        stroke: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgCloud;